/**
 * Auth Storage Helpers (Tenant / Admin 분리)
 * @description 로그인 Entry 분리 시 Client 캐시 충돌 방지를 위한 저장소 prefix 분리
 */

import { AuthStorage } from '@shared/auth';
import { getCurrentPath } from '@shared/router';

export const AUTH_STORAGE_PREFIX_TENANT = 'iampam_auth_tenant';
export const AUTH_STORAGE_PREFIX_ADMIN = 'iampam_auth_admin';

let tenantStorage: AuthStorage | null = null;
let adminStorage: AuthStorage | null = null;

export function getTenantAuthStorage(): AuthStorage {
  if (!tenantStorage) {
    tenantStorage = new AuthStorage(AUTH_STORAGE_PREFIX_TENANT);
  }
  return tenantStorage;
}

export function getAdminAuthStorage(): AuthStorage {
  if (!adminStorage) {
    adminStorage = new AuthStorage(AUTH_STORAGE_PREFIX_ADMIN);
  }
  return adminStorage;
}

export type AuthRealm = 'tenant' | 'admin';

/**
 * 경로 기준 realm 판별
 */
export function getRealmFromPath(path: string): AuthRealm {
  return path.startsWith('/admin') ? 'admin' : 'tenant';
}

/**
 * API 요청 시 현재 경로에 맞는 토큰 반환
 * - /admin/*, /workflow-settings → Admin 저장소 토큰 우선, 없으면 Tenant 저장소 (Tenant 사용자 권한 접근)
 * - 그 외 → Tenant 저장소만
 */
export function getAuthTokenForRequest(path?: string): string | null {
  const currentPath = path ?? getCurrentPath();
  if (currentPath.startsWith('/admin') || currentPath === '/workflow-settings') {
    return getAdminAuthStorage().getToken() || getTenantAuthStorage().getToken();
  }
  return getTenantAuthStorage().getToken();
}
